export const updatePasswordFormName = "UpdatePasswordForm";
